import type { I18nProps } from 'app.types';
import type { GetServerSidePropsResult } from 'next';

import { TemplateDevice } from 'components/pagesComponents/devices/template';

import { wrapper } from 'redux-store';
import { getExperiments, setOneLinkUrl } from 'redux-store/slices/experiments';
import { LandingsActions } from 'redux-store/slices/landings';
import { setUserAgent } from 'redux-store/slices/ui';
import getProfileThunk from 'redux-store/thunks/profile/getProfileThunk';

import { startSpanAndSetTransaction } from 'utils/APMService';
import { isRequestAuthenticated } from 'utils/auth/isRequestAuthenticated';
import getTranslate from 'utils/getTranslate';

export default TemplateDevice;

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async (context): Promise<GetServerSidePropsResult<I18nProps>> => {
      const endSpan = startSpanAndSetTransaction(context.resolvedUrl);
      const page = context.params?.page as string;
      const isAuthenticated = isRequestAuthenticated(context.req);

      if (isAuthenticated) {
        await store.dispatch(getProfileThunk(context));
      }

      store.dispatch(
        setOneLinkUrl({
          query: context.query,
        }),
      );
      store.dispatch(setUserAgent(context.req.headers['user-agent']));
      store.dispatch(
        getExperiments({
          cookies: context.req.cookies,
          setCookie: context.res.getHeader('set-cookie'),
        }),
      );

      let dataPage;

      try {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        dataPage = require(`./data/${page}.json`);
      } catch (e) {
        return {
          notFound: true,
        };
      }

      store.dispatch(LandingsActions.setData(dataPage));

      endSpan();

      return {
        props: {
          ...(await getTranslate(context)),
        },
      };
    },
);
